import { MatPaginator } from '@angular/material/paginator'
import { MatSort } from '@angular/material/sort'
import { Observable } from 'rxjs'
import { FormGroup } from '@angular/forms'

import { Device } from '@shared/models/device.model'
import { AbstractApiDataSource } from '@app/core/services/abstract-api.datasource'
import { DevicesService } from '../../modules/devices/devices.service'
import { FilterValues } from '@shared/models/filter-values.model'
import { ExportFileTypes } from '@shared/models/export-file-types.enum'
import { PagesData } from '@shared/models/pages-data.model'

export class DeviceListDatasource extends AbstractApiDataSource<Device> {
  constructor(
    protected deviceService: DevicesService,
    sort: MatSort,
    paginator: MatPaginator,
    form: FormGroup,
    protected resellerId?: string | number,
  ) {
    super(sort, paginator, form)
  }

  private readonly fields: (keyof Device | string)[] = [
    'id',
    'vendor.name',
    'model.name',
    'usage',
    'team',
    'addedToTeam',
    'ownership',
    'contractStartAt',
    'contractFinishAt',
    'contractId',
    'deviceInstallation.vehicle',
    'deviceInstallation.installDate',
    'status',
    'plan',
    'isDeactivated',
    'statusExt',
    'imei',
    'imsi',
    'iccid',
    'phone',
    'lastDataReceivedAt',
    'deactivatedAt',
    'reseller',
    'team.chevronAccountId',
  ]

  getApiData(sortValue: string, filterValues: { [p: string]: string | number }): Observable<PagesData<Device>> {
    return this.resellerId
      ? this.deviceService.getResellerDevices(
          this.resellerId,
          this.paginator.pageIndex + 1,
          this.paginator.pageSize,
          sortValue,
          filterValues,
        )
      : this.deviceService.getDevices(this.paginator.pageIndex + 1, this.paginator.pageSize, sortValue, filterValues, this.fields)
  }

  getApiFileData(columns: string[], sortValue: string, filterValues: FilterValues, type: ExportFileTypes): Observable<string> {
    return this.resellerId
      ? this.deviceService.exportResellerFile(this.resellerId, columns, sortValue, filterValues, type)
      : this.deviceService.exportFile(columns, sortValue, filterValues, type)
  }
}
